export default {
    delete: {
        list: 'Delete',
        confirm: 'Yes, delete now',
        content: 'You delete the trend radar for the entire company.',
        notice: 'Note: This action cannot be undone.',
        success: 'The trend radar was successfully deleted.',
        title: 'Are you sure you want to delete the trend radar "{title}"?'
    },
    copy: {
        list: 'Copy',
        confirm: 'Yes, copy now',
        title: 'Are you sure you want to copy the trend radar "{title}"?',
        success: 'The trend radar was successfully copied.',
        defaultTitle: 'Copy of {title}',
        label: 'Title of trend radar copy',
        validation: {
            required: 'Please enter a title'
        }
    }
}
